import { useStore } from 'effector-react'
import { StringParam, useQueryParam, withDefault } from 'use-query-params'
import { leadLoginFx } from '~/features/auth/Login/model'
import { ConfirmCodeStep } from '~/features/SimplifiedRegistration/ConfirmCodeStep'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { PageContainer } from '~/shared/ui/PageContainer'

export function SimplifiedRegistrationConfirmPage() {
  const [phone] = useQueryParam('phone', withDefault(StringParam, ''))
  const isSubmitting = useStore(leadLoginFx.pending)

  const handleCodeSubmit = (code: string) => {
    if (!phone) {
      snackbarEnqueued({
        message: 'Номер телефона не может быть пустым',
        variant: 'warning',
      })
      return
    }
    leadLoginFx({ phone, code })
  }

  const handleCodeRepeat = () => {
    snackbarEnqueued({
      message: 'Для повторного получения кода вернитесь к началу регистрации',
      variant: 'warning',
    })
  }

  return (
    <PageContainer title='Регистрация' canBack={false}>
      <ConfirmCodeStep
        phone={phone}
        onOk={handleCodeSubmit}
        isSubmitting={isSubmitting}
        onCodeRepeat={handleCodeRepeat}
      />
    </PageContainer>
  )
}
